import { render, staticRenderFns } from "./PanelAccountSettingsAgreements.vue?vue&type=template&id=2d8e49cf&scoped=true&"
import script from "./PanelAccountSettingsAgreements.vue?vue&type=script&lang=js&"
export * from "./PanelAccountSettingsAgreements.vue?vue&type=script&lang=js&"
import style0 from "./PanelAccountSettingsAgreements.vue?vue&type=style&index=0&id=2d8e49cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8e49cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d8e49cf')) {
      api.createRecord('2d8e49cf', component.options)
    } else {
      api.reload('2d8e49cf', component.options)
    }
    module.hot.accept("./PanelAccountSettingsAgreements.vue?vue&type=template&id=2d8e49cf&scoped=true&", function () {
      api.rerender('2d8e49cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PanelAccountSettingsAgreements.vue"
export default component.exports